import React from 'react';
import { Box, Divider, Typography } from '@mui/material';

const money = value => new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(Number(value || 0));
export default function CreditNoteSummary({ invoice }) {
  const snapshot = invoice.credit_note_snapshot;
  return <Box>
    <Typography variant="h6" gutterBottom>Voci della nota di credito</Typography>
    {snapshot.rows.filter(row => Number(row.amount) !== 0).map(row => <Box key={row.key} sx={{ py: 1, display: 'flex', justifyContent: 'space-between', gap: 2 }}>
      <Typography variant="body2" sx={{ overflowWrap: 'anywhere' }}>{row.description}</Typography><Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>{money(row.amount)}</Typography>
    </Box>)}
    <Divider sx={{ my: 1 }}/><Typography>Imponibile: {money(invoice.f_tot_parz)}</Typography><Typography>IVA {snapshot.vat_rate}%: {money(invoice.f_gas_iva)}</Typography>
    {invoice.note && <Box sx={{ mt: 2 }}><Typography variant="subtitle2">Motivo / note</Typography><Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{invoice.note}</Typography></Box>}
  </Box>;
}
